<script setup>
import Button from "primevue/button";
import Avatar from "primevue/avatar";
import {Link, router} from "@inertiajs/vue3";
import { trans } from 'laravel-vue-i18n'
import {getFormType, getInitials} from "../../../../helpers.js";
import DashboardCard from "../../components/ui-components/dashboard/DashboardCard.vue";
import Chart from "primevue/chart";
import {computed} from "vue";
import {useConfirm} from "primevue/useconfirm";
import ConfirmPopup from "primevue/confirmpopup";
import DataLayout from "../../components/ui-components/data/DataLayout.vue";
const confirm = useConfirm();

defineProps({
    workers: Array,
    worker: Object,
    isExpanded: Boolean,
})

const chartData = (stats) => ({
    labels: ['jan','feb','mar','apr','may','jun','jul','aug','sep','oct','nov','dec'].map(m => trans(`common.months.${m}`)),
    datasets: [
        {
            label: trans('workers.chart_reservations'),
            data: stats,
            fill: false,
            tension: 0.3
        }
    ]
})

const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,animation: false,
    plugins: {
        legend: { display: false },
        tooltip: { enabled: false },
        // Jednoduché kostkaté pozadí jen pro efekt
        beforeDraw: (chart) => {
            const ctx = chart.ctx;
            const width = chart.width;
            const height = chart.height;
            const size = 10; // menší kostky, decentní
            ctx.save();
            ctx.fillStyle = 'rgba(255,255,255,0.05)';
            for (let x = 0; x < width; x += size) {
                for (let y = 0; y < height; y += size) {
                    ctx.fillRect(x, y, size - 1, size - 1);
                }
            }
            ctx.restore();
        }
    },
    scales: {
        x: { display: false },
        y: { display: false }
    },
    elements: {
        line: {
            tension: 0,
            borderColor: '#f97316', // nebo jiná "aesthetic" barva
            borderWidth: 2,
            fill: false,
            pointRadius: 0
        }
    }
}


const confirmDelete = (event, id) => {
    confirm.require({
        target: event.currentTarget,
        group: "workers",
        message: trans('workers.confirm_delete'),
        icon: 'pi pi-trash',
        rejectProps: {
            label: trans('common.cancel'),
            severity: 'secondary',
            outlined: true
        },
        acceptProps: {
            label: trans('common.delete'),
            severity: 'danger'
        },
        accept: () => {
            router.delete(`/app/workers/${id}`)
        },
        reject: () => {
            // Nepotřebuješ nic
        }
    });
};
</script>

<template>
    <ConfirmPopup group="workers"></ConfirmPopup>
    <data-layout :data="workers" :is-expanded="isExpanded" :current-id="worker?.id" default-view="grid" disable-view-changing :search-by="['name']">
        <template #grid-item="{item, selected}">
            <DashboardCard
                :selected="selected">
                <template #image>
                    <Chart type="line" :data="chartData(item.stats?.by_months || [])" :options="chartOptions" class="w-full h-16 mb-4 border rounded-lg px-4 bg-neutral-100"/>
                </template>
                <template #body></template>
                <template #header>
                    <div class="flex items-center justify-between gap-4 w-full">
                        <div class="flex items-center gap-3 overflow-hidden grow">
                            <Avatar :label="getInitials(item.name)" shape="circle"></Avatar>
                            <h4 class="text-lg font-bold truncate text-gray-900 dark:text-white">
                                {{ item.name }}
                            </h4>
                        </div>
                    </div>
                </template>
                <template #main-actions>
                    <Link :href="`/app/workers/${item.id}`">
                        <Button
                            icon="pi pi-pencil"
                            rounded
                            text
                            severity="secondary"
                            v-tooltip.bottom="$t('workers.tooltip_edit')"
                            class="hover:bg-gray-100 dark:hover:bg-gray-700"
                            @click="router.visit('/app/forms/' + item.slug, { preserveState: false, preserveScroll: true })"
                        />
                    </Link>

                    <Button
                        icon="pi pi-trash"
                        rounded
                        text
                        @click="confirmDelete($event, item.id)"
                        severity="danger"
                        v-tooltip.bottom="$t('workers.tooltip_delete')"
                        class="hover:bg-gray-100 dark:hover:bg-gray-700"
                    />
                </template>
            </DashboardCard>
        </template>
        <template #empty>
            <div class="w-full p-16 h-full min-h-full flex flex-col gap-6 justify-center items-center text-center">
                <img src="../../../../../images/glass/Profile.png" alt="No clients illustration" class="w-48 h-48 mb-6 mx-auto" />
                <h2 class="text-2xl font-semibold text-gray-700 dark:text-gray-300">{{ $t('workers.empty_title') }}</h2>
                <p class="text-gray-500 dark:text-gray-400 max-w-md mx-auto">
                    {{ $t('workers.empty_description') }}
                </p>

                <Link href="/app/workers/create">
                    <Button
                        :label="$t('workers.btn_add')"
                        icon="pi pi-plus"
                        class="mt-4"
                        severity="primary"
                        rounded
                    />
                </Link>
            </div>
        </template>
    </data-layout>

</template>

<style scoped lang="scss">

</style>
